module.exports = __webpack_public_path__ + "static/media/ZiXun1.fe39ad88.png";